import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";
import AuthValidation from "../../validation/AuthValidation";

export class LoginRequest implements IRequestModel {

    constructor(user: string, password: string) {
        this.user = user;
        this.password = password;
    }

    uri: string = "auth/login";
    method: HttpMethod = HttpMethod.POST;

    user: string;
    password: string;

    isValid(): ValidationResponse {
        let userResp: ValidationResponse = AuthValidation.UserValid(this.user, "Username or Email");
        if (!userResp.isSuccess) {
            return userResp;
        }

        let passResp: ValidationResponse = AuthValidation.PasswordValid(this.password, "Password");
        return passResp;
    }
}